<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Presupuestos</h1>
            </v-flex>
        </v-layout>
        <v-card>
            <v-card-text>
                <v-layout>
                    <v-flex>
                        <v-alert :value="true" type="info">
                            La utilización de filtros limitará los registros. A fin de obtener todos los registros no elija ninguna opción
                        </v-alert>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex>
                        <v-select label="Rango de fecha" v-model="d.rango" :items="rangos"></v-select>
                    </v-flex>
                    <v-flex>
                        <v-menu
                                lazy
                                :close-on-content-click="false"
                                v-model="d.desdeMenu"
                                :return-value.sync="d.desdeMenu"
                                ref="desdeMenu"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Desde"
                                    v-model="d.desde"
                                    prepend-icon="event"
                                    readonly></v-text-field>
                            <v-date-picker
                                    v-model="d.desde"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="d.desdeMenu = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex>
                        <v-menu
                                lazy
                                :close-on-content-click="false"
                                v-model="d.hastaMenu"
                                :return-value.sync="d.hastaMenu"
                                transition="v-scale-transition"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Hasta"
                                    v-model="d.hasta"
                                    prepend-icon="event"
                                    readonly
                                    ref="hastaMenu"
                            ></v-text-field>
                            <v-date-picker
                                    v-model="d.hasta"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="d.hastaMenu =false"
                            ></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex>
                        <tipo-item-select label="Filtrar Item" v-model="d.tipoItem" multiple></tipo-item-select>
                    </v-flex>
                </v-layout>
                <v-layout align-center justify-center>
                    <v-flex>
                        <estado-select v-model="d.estado_id" label="Filtrar estados" multiple></estado-select>
                    </v-flex>
                    <v-flex>
                        <user-select v-model="d.user_id" label="Filtrar usuarios" :chips="true" multiple></user-select>
                    </v-flex>
                    <v-flex>
                        <user-select v-model="d.vendedor_id" label="Filtrar vendedores" :chips="true" multiple></user-select>
                    </v-flex>
                    <v-flex>
                        <user-select v-model="d.distribuidor_id" label="Filtrar distribuidores" :chips="true" multiple></user-select>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex>
                        <v-select label="Columnas de encabezado" multiple :items="colEncab" v-model="d.colEncab"></v-select>
                    </v-flex>
                    <v-flex>
                        <v-select label="Columnas de items" multiple :items="colItems" v-model="d.colItems"></v-select>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex>
                        <v-radio-group v-model="d.mostrarItems" row>
                            <v-radio label="Solo encabezados" :value="false"></v-radio>
                            <v-radio label="Encabezados e items" :value="true"></v-radio>
                        </v-radio-group>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn dark color="blue" @click="generar" :loading="loading">Generar</v-btn>
            </v-card-actions>
        </v-card>

    </v-container>
</template>

<script>
    import {mapActions} from 'vuex';
    import estadoSelect from '../../components/EstadoSelect';
    import userSelect from '../../components/UserSelect';
    import tipoItemSelect from '../../components/TipoItemSelect';
    import saveAs from 'file-saver';

    export default {
        name: "presupuesto",
        components: {userSelect, estadoSelect, tipoItemSelect},
        data() {
            return {
                loading: false,
                d: {
                    desde: '',
                    desdeMenu: false,
                    hasta: '',
                    hastaMenu: false,
                    estado_id: [],
                    user_id: [],
                    vendedor_id: [],
                    distribuidor_id: [],
                    tipoItem: [],
                    mostrarItems: false,
                    rango: 'presup',
                    colItems: [],
                    colEncab: []
                },
                rangos: [
                    {value: 'item', text: 'Fecha ingreso de items'},
                    {value: 'presup', text: 'Fecha ingreso de presupuestos'},
                ],
                colItems: [],
                colEncab: []
            }
        },
        mounted() {
            this.$http.post('informes/presupuestos/columnas')
                .then(r => {
                    this.colEncab = r.data.encab;
                    this.colItems = r.data.items;
                })
                .catch(err => {
                    console.error(err);
                })
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            generar() {
                if (!this.d.desde || !this.d.hasta) {
                    this.msjShow({txt: 'Por favor seleccione un rango de fechas', tipo: 2});
                    return false;
                }
                this.loading = true;
                this.$http({
                    method: 'post',
                    url: 'informes/presupuestos/excel',
                    data: this.d,
                    headers: {'Content-Type': 'application/json', 'Accept': 'application/vnd.ms-excel'},
                    responseType: "blob"
                })
                    .then((response) => {
                        saveAs(response.data, 'presupuestos.xlsx');
                        this.loading = false;
                    })
                    .catch((error) => {
                        alert(error);
                        this.loading = false;
                    });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/informes/presupuestos.vue